import { small } from 'components/calls/styles/fonts';
import styled from 'styled-components';

export const ParticipantWrapper = styled.div<{ src: string }>`
  padding: 0px 15px;
  display: flex;
  align-items: center;
  min-height: 50px;

  & > div:first-child {
    background-repeat: no-repeat;
    background-position: center;
    background-size: cover;
    flex-shrink: 0;
    border-radius: 50%;
  }
`;

export const ParticipantNickname = styled.h4`
  margin: 0;
`;

export const ParticipantId = styled.div`
  ${small};
`;
